import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectNotificationsStatus } from '../../../../../../notifications/gql/fragments/generated/ProjectNotificationsStatus';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type WorkspaceGridProjectFragment = { __typename?: 'Project', adobeAssetId?: string | null, archivedAt?: string | null, deletedAt?: string | null, description?: string | null, fileCount: number, id: string, isLoading?: boolean | null, name: string, rootAssetId: string, private: boolean, storage: number, updatedAt?: string | null, ignoreArchive: boolean, notificationsEnabled?: boolean | null, images: { __typename?: 'Images', image32?: string | null, image256?: string | null, imageBase?: string | null } };

export const WorkspaceGridProject = /*#__PURE__*/ gql`
    fragment WorkspaceGridProject on Project {
  adobeAssetId
  archivedAt
  deletedAt
  description
  fileCount
  id
  images {
    image32
    image256
    imageBase
  }
  isLoading @client
  name
  rootAssetId
  private
  storage
  updatedAt
  ignoreArchive
  ...ProjectNotificationsStatus
}
    ${ProjectNotificationsStatus}` as unknown as DocumentNode<WorkspaceGridProjectFragment, unknown>;

        

        
export const useWorkspaceGridProjectFragment = (
  input: string | Omit<UseFragmentOptions<WorkspaceGridProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<WorkspaceGridProjectFragment>({
    fragment: WorkspaceGridProject,
    fragmentName: 'WorkspaceGridProject',
    ...options,
  });
};
  
        